import Vue from 'vue';
import Vuex from 'vuex';

// Import modules
import auth from './modules/auth';
import account from './modules/account';
import asset from './modules/asset';
import assetComponent from './modules/assetComponent';
import counterparty from './modules/counterparty';
import contract from './modules/contract';
import alternativeContract from './modules/alternativeContract';
import underlyingAssetType from './modules/underlyingAssetType';
import businessUnits from './modules/businessUnits';
import frequency from './modules/frequency';
import paymentType from './modules/paymentType';
import paymentName from './modules/paymentName';
import payment from './modules/paymentParameters';
import currency from './modules/currency';
import currencyRate from './modules/currencyRate';
import coolDropdown from './modules/coolDropdown';
import eventRegistry from './modules/eventRegistry';
import systemSettings from './modules/systemSettings';
import contractDocument from './modules/contractDocument';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    account,
    asset,
    assetComponent,
    counterparty,
    contract,
    alternativeContract,
    underlyingAssetType,
    businessUnits,
    frequency,
    paymentType,
    paymentName,
    payment,
    currency,
    currencyRate,
    coolDropdown,
    eventRegistry,
    systemSettings,
    contractDocument
  },
  state: {
    locales: [{
      id: 'en',
      label: 'English'
    }, {
      id: 'ru',
      label: 'Русский'
    }],
    requiredENV: [
      'WEB_API_URL',
    ],
  },
});

export default store;
